import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Leidsin sama toote mujalt soodsama hinnaga

  <span style="color:#85c1dc;">**FI:**</span>
  Löysin saman tuotteen muualta edullisemmalla hinnalla

  <span style="color:#85c1dc;">**RU:**</span>
  Я нашёл тот же товар в другом месте по более низкой цене
*/
/* @__NO_SIDE_EFFECTS__ */
const m184 = msg(
  mf`Leidsin sama toote mujalt soodsama hinnaga`,
  mf`Löysin saman tuotteen muualta edullisemmalla hinnalla`,
  mf`Я нашёл тот же товар в другом месте по более низкой цене`,
)

export { m184 as 'w.module.product.ask_price.mail.subject' }